import { FormControl, FormHelperText, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import { isNullEmpty } from "../../../utils/validation";
import { getDeliveryPriceAddition } from "../../../http/api/MasterAPI";

const DeliveryPriceAdditionSelect = ({ value, error, onChangeValue }) => {
  const [ListDeliveryPriceAdditionSelect, setListDeliveryPriceAdditionSelect] = useState([]);
  
  async function getDeliveryPriceAdditionSelect() {
    try {
      const response = await getDeliveryPriceAddition();//納品価格
      const varList = response.masterVarInfo;
      const result = varList
        .map((element) => ({
          deliveryPriceAdditionCd: element.varCd,
          deliveryPriceAdditionName: element.varValue1,
        }))
        .filter(
          (x) => x.deliveryPriceAdditionName && x.deliveryPriceAdditionName.trim() !== ""
        );
      setListDeliveryPriceAdditionSelect(result);
    } catch (error) {
      console.error("Failed to fetch shop info:", error);
    }
  }

  useEffect(() => {
    getDeliveryPriceAdditionSelect();
  }, []);

  return (
    <FormControl>
      <Select
        value={value}
        onChange={(e) => onChangeValue(e.target.value)}
        sx={{ width: 200 }}
        error={!isNullEmpty(error)}
       // onFocus={ () => validate.handleTouch("deliveryPriceAdditionCd")}
      >
        {ListDeliveryPriceAdditionSelect.map((item) => (
          <MenuItem
            key={"deliveryPriceAddition" + item.deliveryPriceAdditionCd}
            value={item.deliveryPriceAdditionCd}
          >
            {item.deliveryPriceAdditionName}
          </MenuItem>
        ))}
      </Select>
      {!isNullEmpty(error) && (
        <FormHelperText sx={{color:"#d32f2f",  marginLeft: 0 }}>{error}</FormHelperText>
      )}
    </FormControl>
    
  );
};

export default DeliveryPriceAdditionSelect;